import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, noop, Observable, tap } from 'rxjs';
import { environment } from 'projects/shared/environments/environment';
import { MobileToasterService } from 'projects/shared/components/mobile-toaster/services/mobile-toaster.service';
import { BrowserService } from 'projects/shared/services/browser.service';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class IpService {
  ip$ = new BehaviorSubject<string>('')
  constructor(
    private http: HttpClient,
    private _mobileToaster: MobileToasterService,
    private _browserService: BrowserService,
    private _messageService: MessageService
  ) { }

  getPublicIp(): Observable<any> {
    return this.http.get(`${environment.apiUrl}utils/get-ip`, { withCredentials: true });
  }

  async getIP() {
    this.getPublicIp().pipe(
      tap(
        res => {
          this.ip$.next(res.ip)
        }
      )
    ).subscribe(noop, err => {
      if (this._browserService.getWindow()) {
        if (window.innerWidth < 769) {
          this._mobileToaster.MobileToaster$.next({ severity: 'error', summary: 'Error', detail: err.error.message })
        } else {
          this._messageService.add({ severity: 'error', summary: 'Error', detail: err.error.message })
        }
      }
    })
  }

}